<script lang="ts">
  import ExpandButton from '~/components/buttons/ExpandButton.svelte';
  import { fade } from 'svelte/transition';
  import ReplayClassic from './ReplayClassic.svelte';
  import { getGame } from '~/store/GameContext.svelte';
  import { ClassicGame } from '~/store/classic.svelte';

  type Props = {
    open: boolean;
  };
  const props: Props = $props();
  const game = $derived(getGame<ClassicGame>().current);
</script>

<div class="score-container">
  <div class="button-container">
    <ExpandButton open={props.open} />
  </div>
  <h1>
    Score: {game.score}
  </h1>
  <div class="button-container">
    {#if !open}
      <div transition:fade>
        <ReplayClassic iconOnly />
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .score-container {
    line-height: 1;
    width: 100%;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    justify-content: space-between;
    h1 {
      margin: 0;
    }
    .button-container {
      width: 44px;
      height: 44px;
    }
  }
</style>
